<template>
<div id="news">

</div>
</template>

<script>
export default {
  name: "News",
  components: {}
};
</script>

<style lang="scss" scoped>
#news {
  width: 100%;
  height: 100%;
}
</style>
